import { type Message, StyledPillButton, strings, text } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { HostId } from "../state/uploaderState";

function ToggleFilesPanelButton({
	id = "files-panel-button",
	testId = "files-panel-button-done",
}: { id?: string; testId?: string } = {}) {
	let toAuthorBC: BroadcastChannel;
	const hostId = useRecoilValue(HostId);

	const toggle = () => {
		const message: Message = {
			hostId,
			type: "fileUploader",
			action: strings.messages.toggleFilesPanel,
		};
		toAuthorBC.postMessage(message);
	};

	useEffect(() => {
		toAuthorBC = new BroadcastChannel(strings.broadcastChannel.author);
		return () => {
			toAuthorBC.close();
		};
	});

	return (
		<StyledPillButton id={id} data-testid={testId} onClick={() => toggle()}>
			{text.ui.done}
		</StyledPillButton>
	);
}

export default ToggleFilesPanelButton;
